import React, { useState, useEffect } from "react";
import { ActualizarAgenteRetencion } from "../../hacienda/actividadEconomica/modalActualizarAgenteRetencion";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import axios from "axios";
import { Toasts } from "../../toasts";
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";
const headCells = [
  {
    id: "idcomercio",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "ritm",
    label: "RITM",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "rif",
    label: "RIF",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "nombre",
    label: "NOMBRE",
    width: "250px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "reprelegal",
    label: "CEDULA",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
];

function TablaComercio4(props) {
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [statusCome, setStatusCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [retencion, setRetencion] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const [ipMac] = useState({
    ip: localStorage.getItem("ip"),
    mac: localStorage.getItem("mac"),
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState(
    JSON.parse(localStorage.getItem("accagente"))
  );
  const [horaope, setHoraope] = useState();
  const [declaWeb, setDeclaWeb] = useState(false);
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idagenteretencion.includes(target.value) === null
                ? ""
                : x.idagenteretencion.includes(target.value)) ||
              (x.ritm === null
                ? ""
                : x.ritm.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.rif === null
                ? ""
                : x.rif.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.nombre === null
                ? ""
                : x.nombre
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.reprelegal === null ? "" : x.reprelegal.includes(target.value))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    setActivate(true);
    setRecords([]);
    let endpoint = `${op.conexion}/api/industria/allagentes`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const selectSta = () => {
    let endpoint = `${op.conexion}/api/industria/statuscomercio`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setStatusCome(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectConfig = () => {
    let endpoint = op.conexion + "/api/industria/configuracionindustria";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setDeclaWeb(response.data.declaweb);
          if (response.data.valorutMulta === null) {
            if (response.data.factormulta === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Información",
                texto:
                  "El valor de la unidad tributaria para el año " +
                  anioActu +
                  " no esta definido",
                icono: "informacion",
              });
            } else if (response.data.factormulta > 2) {
              let tipo = response.data.factormulta - 3;

              setMensaje({
                mostrar: true,
                titulo: "Información",
                texto:
                  "El valor del " +
                  (tipo === 0
                    ? "Petro"
                    : tipo === 1
                    ? "Sueldo Minimo"
                    : tipo === 2
                    ? "UCAMP"
                    : "") +
                  " para el año " +
                  anioActu +
                  " en el mes en curso no esta definido",
                icono: "informacion",
              });
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const SelectPersona = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setPersona(response.data);
            if (!declaWeb) {
              setActivate(false);
              setMostrar5(true);
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const SelectUsuarioWeb = (id) => {
    let endpoint = `${op.conexion}/api/industria/oneagente?idcomercio=${id}`;
    console.log(endpoint);

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            var uw = [];
            for (let i = 0; i < response.data.length; i++) {
              uw.push({
                idusuarioweb: response.data[i].idusuarioweb,
                login: response.data[i].login,
                nombre: response.data[i].nombre,
              });
            }

            setUsuariow(uw);
            seleccionarRetenciones(id);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const SelectReten = (id) => {
    let endpoint = `${op.conexion}/api/industria/oneagente?idcomercio=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setRetencion(response.data);
            console.log(response.data);
            setMostrar5(true);
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarComercios = () => {
    setActivate(true);
    seleccionarRegistros();
  };

  const renderizar = () => {
    seleccionarComercios();
  };

  const seleccionarStatus = () => {
    selectSta();
  };

  const seleccionarConfiguracion = () => {
    SelectConfig();
  };

  const seleccionarUsuarioWeb = (idC) => {
    SelectUsuarioWeb(idC);
  };

  const seleccionarRetenciones = (idC) => {
    SelectReten(idC);
  };

  const agregarComercio = (per) => (e) => {
    e.preventDefault();
    if (per.toString() === "1") {
      setOperacion(1);
      setComercio();
      setUsuariow();
      setPersona();
      setDeshabilitado(false);
      setMostrar5(true);
    } else {
      setToast({
        mostrar: true,
        mensaje: "No posee permiso para Registrar",
        titulo: "Alerta.",
      });
    }
  };

  const consultarComercio = (item, per) => (event) => {
    event.preventDefault();
    if (per.toString() === "1") {
      setDeshabilitado(true);
      setOperacion(4);
      setActivate(true);
      setComercio(item);

      if (declaWeb) {
        SelectPersona(item.reprelegal);
        seleccionarUsuarioWeb(item.idagenteretencion);
      } else {
        SelectPersona(item.reprelegal);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje: "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const editarComercio = (item, per) => (event) => {
    event.preventDefault();
    if (per.toString() === "1") {
      setDeshabilitado(false);
      setOperacion(2);
      setActivate(true);
      setComercio(item);
      if (declaWeb) {
        SelectPersona(item.reprelegal);
        seleccionarUsuarioWeb(item.idagenteretencion);
      } else {
        SelectPersona(item.reprelegal);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje: "No posee permiso para Editar",
        titulo: "Alerta.",
      });
    }
  };

  const eliminarComercio = (item, per) => (event) => {
    event.preventDefault();
    if (per.toString() === "1") {
      setDeshabilitado(true);
      setOperacion(3);
      setActivate(true);
      setComercio(item);
      SelectPersona({
        variables: {
          cedula: item.reprelegal,
        },
      });
      if (declaWeb) {
        seleccionarRetenciones(item.idagenteretencion);
        seleccionarUsuarioWeb(item.idagenteretencion);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje: "No posee permiso para Eliminar",
        titulo: "Alerta.",
      });
    }
  };

  const validarActuComercio = () => {
    if (operacion === 4) {
      setComercio();
      setMostrar5(false);
      return;
    }

    setComercio();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    renderizar();
  };

  const cerrarModalActualizar = () => {
    setComercio();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    renderizar();
  };

  useEffect(() => {
    seleccionarRegistros();
    let obj = JSON.parse(localStorage.getItem("post"));
    // setPermiso(
    //   JSON.parse(localStorage.getItem("permisos")).acccontribuyente
    // );
    setIdUsuario(obj.idusuario);
    setEspiritu(obj.espiritu);
    setHoraope(obj.horaope);
    seleccionarStatus();
    seleccionarConfiguracion();
  }, []);

  useEffect(() => {});

  const cerrar = () => {
    props.setTabla(0);
  };
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  return (
    <div className="col-8 m-0 p-2 border rounded mx-auto mt-5">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
            <h3 className="fw-bold m-0">Gestion de Agentes Retención</h3>
            <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
            Salir <i className="fas fa-times ms-2"></i>
            </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-6 col-lg-4 m-0 p-0">
            <SearchInput
                placeholder="Buscar"
                onChange={handleSearch}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton icon = "fa-plus m-0"
              onClick={agregarComercio(
              permiso.toString().substring(1, 2)
              )}
              disabled={permiso.toString().substring(1, 2) !== "1"} 
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
              <TblHead />
              <tbody>
              {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                      key={item.idagenteretencion}
                      style={{ padding: "0" }}
                  >
                      <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                      >
                      {item.idagenteretencion}
                      </td>
                      <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                      >
                      {item.ritm}
                      </td>
                      <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                      >
                      {item.rif}
                      </td>
                      <td
                      className="align-baseline"
                      style={{ textAlign: "left" }}
                      >
                      {item.nombre}
                      </td>
                      <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                      >
                      {item.reprelegal}
                      </td>
                      <td className="d-flex gap-1">
                      <button
                          title="Consultar Agente"
                          onClick={consultarComercio(
                          item,
                          permiso.toString().substring(0, 1)
                          )}
                          className={
                          permiso.toString().substring(0, 1) === "1"
                              ? "btn btn-sm btn-info rounded-circle"
                              : "btn btn-sm btn-secondary rounded-circle"
                          }
                      >
                          <i className="fas fa-eye"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                          title="Editar Agente"
                          onClick={editarComercio(
                          item,
                          permiso.toString().substring(2, 3)
                          )}
                          className={
                          permiso.toString().substring(2, 3) === "1"
                              ? "btn btn-sm btn-warning rounded-circle"
                              : "btn btn-sm btn-secondary rounded-circle"
                          }
                      >
                          <i className="fa fa-edit"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                          title="Eliminar Agente"
                          onClick={eliminarComercio(
                          item,
                          permiso.toString().substring(3, 4)
                          )}
                          className={
                          permiso.toString().substring(3, 4) === "1"
                              ? "btn btn-sm btn-danger rounded-circle"
                              : "btn btn-sm btn-secondary rounded-circle"
                          }
                      >
                          <i className="fa fa-trash-alt"></i>{" "}
                      </button>
                      </td>
                  </tr>
                  ))}
              </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ActualizarAgenteRetencion
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuComercio}
        comercio={comercio}
        statuscome={statusCome}
        usuarioweb={usuariow}
        representante={persona}
        tabreten={retencion}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={declaWeb}
        idusuario={idUsuario}
        operacion={operacion}
        anioActu={anioActu}
        ipMac={ipMac}
        horaope={horaope}
        espiritu={espiritu}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaComercio4;
